import { VerticalType } from '../api/CoachingForm/schema';
import { Profile } from '../Types';
import { checkGoUser } from './User';

export const getUserIdWithPrefix = (
  cscEntityPrefix: string,
  userId: string
) => {
  return `${cscEntityPrefix}:${userId}`;
};

const convertEnumToObject = (
  enumObject: Record<string, string | number>
): Record<string, string> => {
  const indexes = Object.values(enumObject).filter(
    value => typeof value === 'string'
  );

  const object = indexes.reduce((obj, key) => ({ ...obj, [key]: key }), {});
  return object;
};

export const partitionArray = (
  array: any[],
  isValid: any,
  maxElementInFirstPartition = Number.MAX_SAFE_INTEGER,
  maxElementInSecondPartition = Number.MAX_SAFE_INTEGER
) => {
  if (maxElementInFirstPartition < 0 || maxElementInSecondPartition < 0) {
    throw Error('maxElement cannot be negative');
  }

  const reduceWithMaxElement = (
    reduceArray: any[],
    elem: any,
    maxElement: number
  ): any[] => {
    return (reduceArray ?? []).length === maxElement
      ? reduceArray
      : [...reduceArray, elem];
  };

  // Ref: https://stackoverflow.com/a/47225591
  return array.reduce(
    ([firstPartition, secondPartition], elem) => {
      return isValid(elem)
        ? [
            reduceWithMaxElement(
              firstPartition,
              elem,
              maxElementInFirstPartition
            ),
            secondPartition,
          ]
        : [
            firstPartition,
            reduceWithMaxElement(
              secondPartition,
              elem,
              maxElementInSecondPartition
            ),
          ];
    },
    [[], []]
  );
};

export const isRunningTest = (): boolean => {
  return process.env.JEST_WORKER_ID !== undefined;
};

export default convertEnumToObject;

export const mapCapAndConsumerToV2ForTrend = (
  vertical: VerticalType,
  profile: Profile | undefined
): VerticalType => {
  // Currently we are only mapping to V2 for Consumer and Cap as we are removing RAP for these two verticals.
  // The mapping for the rest of the verticals will be done as part of https://sim.amazon.com/issues/CSKoala-1746.
  if (vertical === 'Consumer' || vertical === 'CAP' || vertical == 'Total') {
    if (profile && checkGoUser(profile.user?.owner)) {
      return `${vertical}_GO_V2` as VerticalType;
    } else {
      return `${vertical}_V2` as VerticalType;
    }
  }
  return vertical;
};
